'use es6';

export const getUser = state => state.auth && state.auth.user;